const error = {
  header: 'Hoppla!',
  lead: 'Da ist wohl leider etwas schiefgelaufen...',
  icon: 'emoji-frown',
  msg: 'Bitte laden Sie die Seite neu. Sollte der Fehler weiterhin bestehen, können Sie gerne Kontakt mit uns aufnehmen. Wir helfen Ihnen gerne weiter!',
  btn: {
    text: 'Seite neu laden',
    icon: 'arrow-clockwise'
  }
}

export default {
  error
}
